module.exports = __webpack_public_path__ + "img/gongsi.d27544dc.png";